<template>
  <div class="bg-blue">
    <md-button
      class="md-icon-button person-icon bg-white mb-0 ml-4"
      @click="clickEditLink()"
    >
      <md-icon class="md-size-2x">person</md-icon>
    </md-button>
    <p class="white f-size-14 ml-3 mb-1">{{ userName }}</p>

    <md-list class="pl-3">
      <md-list-item
        :to="{ name: 'Home' }"
        @click="$emit('changeMenuVisible')"
        exact
      >
        <md-icon class="mr-4">home</md-icon>
        <span class="md-list-item-text">ホーム</span>
      </md-list-item>

      <md-list-item
        :to="{ name: 'TrialIndex' }"
        @click="$emit('changeMenuVisible')"
        exact
      >
        <md-icon class="mr-4">monetization_on</md-icon>
        <span class="md-list-item-text">料金・納期</span>
      </md-list-item>

      <md-list-item
        :to="{ name: 'EstimateIndex' }"
        @click="$emit('changeMenuVisible')"
        exact
      >
        <md-icon class="mr-4">article</md-icon>
        <span class="md-list-item-text">お見積り履歴</span>
      </md-list-item>

      <md-list-item
        :to="{ name: 'OrderIndex' }"
        @click="$emit('changeMenuVisible')"
        exact
      >
        <md-icon class="mr-4">assignment_turned_in</md-icon>
        <span class="md-list-item-text">発注</span>
      </md-list-item>

      <md-list-item
        :to="{ name: 'HistoryIndex' }"
        @click="$emit('changeMenuVisible')"
        exact
      >
        <md-icon class="mr-4">history</md-icon>
        <span class="md-list-item-text">発注履歴</span>
      </md-list-item>

      <!--
      <md-list-item :to="{name: 'Home'}" exact>
        <md-icon class="mr-4">receipt</md-icon>
        <span class="md-list-item-text">{{$t('header.receipt')}}</span>
      </md-list-item>
      -->

      <md-list-item
        :to="{ name: 'SettingIndex' }"
        @click="$emit('changeMenuVisible')"
        exact
      >
        <md-icon class="mr-4">build</md-icon>
        <span class="md-list-item-text">設定</span>
      </md-list-item>

      <md-list-item
        :to="{ name: 'InquiryIndex' }"
        @click="$emit('changeMenuVisible')"
        exact
      >
        <md-icon class="mr-4">contact_mail</md-icon>
        <span class="md-list-item-text">お問い合わせ</span>
      </md-list-item>

      <md-list-item @click="$emit('changeMenuVisible')" exact>
        <b-link @click="logout">ログアウト</b-link>
      </md-list-item>
    </md-list>
  </div>
</template>

<script>
import Mixin from '@/components/mixin/Mixin'
import Store from '@/store/index.js'
export default {
  name: 'Sidebar',
  mixins: [Mixin],
  methods: {
    clickEditLink() {
      this.$emit('changeMenuVisible')
      this.setSettingMyData()
      this.$router.push({ name: 'SettingEdit' })
    },
  },
  computed: {
    userName() {
      if (!Store.state.user.data) return ''
      return (
        (Store.state.user.data.TANTO_MEI_SEI || '') +
        (Store.state.user.data.TANTO_MEI || '')
      )
    },
  },
}
</script>

<style lang="sass" scoped>
.person-icon
  margin: 15px 10px
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue